import * as api from "@novorender/api";

import { telemetry } from "telemetry";

// Exported by the engine switch (src/dev/engineSwitchPlugin.ts), which every `@novorender/api` import resolves to.
const engineSwitch = api as typeof api & { initEngine(): Promise<void> };

let ready: Promise<void> | undefined;

/**
 * Loads the selected engine and points the `@novorender/api` bindings at it. Call before the first
 * synchronous `@novorender/api` call and before defining a subclass of an engine class.
 * @see invertedFlightControllerClass
 * @returns The cached outcome. Never rejects: on failure it stays on `@novorender/api` and the next call retries.
 */
export function initEngine(): Promise<void> {
    // Inside `then` so a synchronous throw also falls back instead of escaping.
    ready ??= Promise.resolve()
        .then(() => engineSwitch.initEngine())
        .catch((error: unknown) => {
            ready = undefined;
            console.error("Failed to load the WASM engine; falling back to @novorender/api.", error);
            telemetry.trackCaughtException({ source: "render.engineInit", category: "init", error, severity: "error" });
        });
    return ready;
}
